import axios from 'axios';
import { GroupedEntitlement } from '../common/model/dto/entitlement';
import { Paginated } from '../common/types';
import { ADMIN_ENTITLEMENT_ROUTE } from '../api/backend';
import { CreateEntitlementRequest } from '../common/model/dto/create-entitlement-request';
import { DeleteEntitlementRequest } from '../common/model/dto/delete-entitlement-request';

export const getGroupedEntitlements = async (
  params: Record<string, unknown>
) => {
  const { data } = await axios.get<Paginated<GroupedEntitlement>>(
    `/${ADMIN_ENTITLEMENT_ROUTE}`,
    { params }
  );

  return data;
};

export const createEntitlement = async (
  createEntitlementRequest: CreateEntitlementRequest | null
) => {
  return await axios.post(
    `${ADMIN_ENTITLEMENT_ROUTE}`,
    createEntitlementRequest
  );
};

export const deleteEntitlement = async (
  deleteEntitlementRequest: DeleteEntitlementRequest | null
) => {
  return await axios.delete(`${ADMIN_ENTITLEMENT_ROUTE}`, {
    data: deleteEntitlementRequest,
  });
};

export const deleteEntitlements = async (
  userRole: string | null,
  clinicRole: string | null,
  resource: string
) => {
  return await axios.delete(
    `${ADMIN_ENTITLEMENT_ROUTE}/${userRole ?? 'NULL'}/${
      clinicRole ?? 'NULL'
    }/${resource}`
  );
};
